import request from '@/utils/request'

const locationURL = {
  List: '/message-push/location-list',
  Detail: '/message-push/location-detail',
  Create: '/message-push/location-create',
  Delete: '/message-push/location-delete',
  Update: '/message-push/location-update'
}

// 位置-列表
export function locationList (data) {
  return request({
    url: locationURL.List,
    method: 'post',
    data
  })
}

// 位置-详情
export function locationDetail (data) {
  return request({
    url: locationURL.Detail,
    method: 'post',
    data
  })
}

// 位置-创建
export function locationCreate (data) {
  return request({
    url: locationURL.Create,
    method: 'post',
    data
  })
}

// 位置-删除
export function locationDelete (data) {
  return request({
    url: locationURL.Delete,
    method: 'post',
    data
  })
}

// 位置-更新
export function locationUpdate (data) {
  return request({
    url: locationURL.Update,
    method: 'post',
    data
  })
}

export default {
  locationList,
  locationDetail,
  locationCreate,
  locationDelete,
  locationUpdate
}
